import { RootState } from "store";

export const selectQuote = (state: RootState) => state.quote;
